export default "__VITE_ASSET__auh7jgPz__"